<div class="screen">

  <app-theme-header [estClickable]="true" (estClick)="host.openPIN(host.content, null)"></app-theme-header>

  <div class="screen__stage">

    <ng-container *ngIf="host.showPayButton">
      <!-- "PAYMENT" per the mockup, not InterfaceText.PAYMENT_OPTION_PAY ("PAY") which the
           default theme uses. Theme-specific copy; the default theme is unaffected. -->
      <button type="button" class="outline-button outline-button--hero" (click)="host.goToPrice()">
        PAYMENT
      </button>
      <button type="button" class="outline-button outline-button--secondary" (click)="host.goToPromoType()"
        *ngIf="host.showPromoButton">
        {{ host.TXT_PAYMENT_OPTION_PROMOTION_BUTTON }}
      </button>
    </ng-container>

    <ng-container *ngIf="!host.showPayButton">
      <button type="button" class="outline-button outline-button--hero" (click)="host.goToPromoType()"
        *ngIf="host.showPromoButton">
        {{ host.TXT_PAYMENT_OPTION_PROMOTION_BUTTON }}
      </button>
      <span class="screen__notice" *ngIf="!host.showPromoButton">
        No Available Payment or Promotion Method. Please Contact Staff.
      </span>
    </ng-container>

  </div>

  <div class="screen__actions">
    <button type="button" class="outline-button" (click)="host.goToHome()">
      {{ host.TXT_GLOBAL_BACK_BUTTON }}
    </button>
  </div>

</div>
